import { css } from 'styled-components';

// 버튼 모양
export const getShapeStyle = (shape) => {
  switch (shape) {
    case 'round50':
      return css`
        border-radius: 50%;
      `;
    case 'round20':
      return css`
        border-radius: 20px;
      `;
    case 'square':
      return css`
        border-radius: 0;
      `;
    default:
      return css`
        border-radius: 6px;
      `;
  }
};
